import { render } from "./solicitudrevision.vue?vue&type=template&id=812b8626"
import script from "./solicitudrevision.vue?vue&type=script&lang=js"
export * from "./solicitudrevision.vue?vue&type=script&lang=js"

import "./solicitudrevision.vue?vue&type=style&index=0&id=812b8626&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__